import { createTheme } from '@mui/material/styles'

const defaultTheme = createTheme()

// Design tokens for the "Panel Klienta 3.0" redesign (Figma).
// Kept separate from palette.primary/secondary until the redesign covers the whole app.
export const r4r = {
  navy: '#1F1F73',
  azure: '#6A8AE5',
  azureDark: '#5B79CA',
  yellow: '#FEC900',
  yellowDark: '#92750A',
  cyan: '#24D4E1',
  violet: '#7F71D3',
  ink: '#1A1A2E',
  red: '#EF4444',
  green: '#10B981',
  grey: '#6B7280',
  greyLight: '#E5E7EB',
  greyBg: '#F3F4F8',
  gradient: 'linear-gradient(135deg, #1F1F73 0%, #6A8AE5 100%)',
  gradientViolet: 'linear-gradient(135deg, #7F71D3 0%, #6A8AE5 100%)',
  gradientCyan: 'linear-gradient(135deg, #1F1F73 0%, #24D4E1 100%)',
  cardShadow: '0px 2px 6px rgba(31, 31, 115, 0.08)',
  heroShadow: '0px 4px 12px rgba(31, 31, 115, 0.18)'
} as const

export type R4RTokens = typeof r4r

declare module '@mui/material/styles' {
  interface Theme {
    r4r: R4RTokens
  }
  interface ThemeOptions {
    r4r?: R4RTokens
  }
}

const theme = createTheme({
  r4r,
  palette: {
    primary: {
      main: '#527EF7'
    },
    secondary: {
      main: '#1d226e'
    },
    text: {
      primary: '#181818',
      secondary: '#5D5D5D'
    }
  },
  shape: {
    borderRadius: 10
  },
  spacing: 8,
  typography: {
    fontFamily: '"Montserrat", sans-serif'
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 4
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#F2F6FF',
          borderRadius: '9px',
          alignItems: 'center',
          padding: '4px',
          [defaultTheme.breakpoints.up('md')]: {
            display: 'inline-flex'
          },
          '.MuiTab-root': {
            padding: '4px 16px',
            flex: 1,
            textTransform: 'none',
            borderRadius: '9px',
            color: '#1D226E',
            maxWidth: 'unset',
            whiteSpace: 'nowrap',
            minHeight: '42px',
            '&.Mui-selected': {
              backgroundColor: '#527EF7',
              color: '#fff'
            }
          }
        },
        indicator: {
          display: 'none'
        }
      }
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontWeight: '700'
        },
        colorPrimary: {
          backgroundColor: '#F2F6FF',
          color: '#527EF7'
        }
      }
    }
  }
})

export default theme
